import React, { forwardRef } from 'react';
import { Send } from 'lucide-react';
import './SellerAssistantInput.css';

const SellerAssistantInput = forwardRef(function SellerAssistantInput(
  { value, onChange, onSubmit, disabled, placeholder },
  ref
) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSubmit(e);
    }
  };

  return (
    <form onSubmit={onSubmit} className="seller-assistant-input-form">
      <div className="seller-assistant-input-wrapper">
        <textarea
          ref={ref}
          rows={3}
          value={value}
          onChange={onChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder || 'Pergunte sobre produtos, estoque, preço ou indicação clínica (ex.: curativo para cicatrização)...'}
          className="seller-assistant-input"
          disabled={disabled}
        />
        <button
          type="submit"
          disabled={!value.trim() || disabled}
          className={`seller-assistant-send-button ${
            value.trim() ? 'seller-assistant-send-button-active' : ''
          }`}
          aria-label="Enviar"
        >
          <Send size={18} />
        </button>
      </div>
    </form>
  );
});

export default SellerAssistantInput;
